// extracted by mini-css-extract-plugin
export default {"privacy":"css_privacy__7RBOu","privacyInner":"css_privacyInner__SCaRm"};